module.exports = __webpack_public_path__ + "img/img_01.f192f13c.png";